
export UserService from './user/user-service';
export BankIdService from './bank-id/bank-id-service';
export InvoiceService from './invoices/invoice-service';
export InvoiceCopyService from './invoice-copy/invoice-copy-service';
export PaymentRequestService from './payment-request/payment-request-service';
export CurrenciesService from './currencies/currencies-service';
export TaxkeyService from './taxkeys/taxkey-service';
export CountryService from './countries/country-service';
export CustomerService from './customers/customer-service';
export EmploymentCertificateService from './employment-certificates/employment-certificate-service';
export InfoService from './info/info-service';
export Utils from './utils/utils';
export WorkerService from './workers/worker-service';
export SupplierLedgerService from './supplier-ledgers/supplier-ledger-service';
export CouponService from './coupons/coupon-service';
export TaxService from './taxes/tax-service';
export IncomeStatementService from './income-statements/income-statement-service';
export AgreementDraftService from './agreement-drafts/agreement-draft-service';
export LogotypeService from './logotype/logotype-service';
export LoyaltyPointService from './loyalty-points/loyalty-point-service';
export InsurancesPageService from './insurances-page/insurances-page-service';
export WorkingEnvironmentPageService from './working-environment-page/working-environment-page-service';
export FaqService from './faq/faq-service';
export UserSettingsConstants from './user/settings-constants';
export SalaryTypeConstants from './salaries/salary-type-constants';
export SalaryPaymentStatusConstants from './salaries/salary-payment-status-constants';



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/index.js
 **/